export enum FeatureName {
	USER_SEAT = 'Rev_Active_User_Seat',
	ACTIVE_USER_SEAT = 'Rev_Monthly_Active_User_Seat',
	VIEWING_HOURS = 'Rev_Viewing_Hours',
	DISTRIBUTION_HOURS = 'Rev_Distribution_Hours',
	AI_HOURS = 'Rev_AI_Hours',
	AI_MICROCREDITS = 'Rev_AI_MicroCredits',
	CONCURRENT_USERS = 'Rev_Concurrent_Users'
}
